























import { Component, Vue, Prop } from 'vue-property-decorator';
import 'highlight.js/styles/monokai-sublime.css';
import format from 'xml-formatter';
import hljs from 'highlight.js/lib/common';

@Component({
  i18n: {
    messages: {
      en: {
        xmlSummary: "XML",
        copy: "Copy",
        copiedToClipboard: "Copied to clipboard",
      },
      nb: {
        xmlSummary: "XML",
        copy: "Kopier",
        copiedToClipboard: "Kopiert til utklippstavle",
      },
    },
  },
})
export default class XmlPolisher extends Vue {
  @Prop({type: Boolean, default: true}) private open!: boolean;
  @Prop({type: String, required: true}) private content!: string;

  private get formattedContent() {
    return format(
      this.content,
      {indentation: '  ', collapseContent: true},
    );
  }

  private get highlightedContent() {
    const highlighting = hljs.highlight(this.formattedContent, {language: 'xml'});
    return highlighting.value;
  }

  private copyToClipboard(): void {
    navigator.clipboard
      .writeText(this.formattedContent)
      .then(() => this.$sMessage.success(this.$t('copiedToClipboard')));
  }
}
